module.exports = __webpack_public_path__ + "img/15.4cb8a6da.jpg";